import { render, staticRenderFns } from "./moreHomePage.vue?vue&type=template&id=ecbd0f2e&scoped=true"
import script from "./moreHomePage.vue?vue&type=script&lang=js"
export * from "./moreHomePage.vue?vue&type=script&lang=js"
import style0 from "./moreHomePage.vue?vue&type=style&index=0&id=ecbd0f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbd0f2e",
  null
  
)

export default component.exports